// Polkadot AssetHub Testnet (Paseo) Configuration
export const NETWORK_CONFIG = {
  chainId: 420420422,
  chainIdHex: '0x190FC4E6',
  name: 'Paseo AssetHub Testnet',
  rpcUrl: 'https://testnet-passet-hub-eth-rpc.polkadot.io',
  explorerUrl: 'https://blockscout-passet-hub.parity-testnet.parity.io',
  nativeCurrency: {
    name: 'PAS',
    symbol: 'PAS',
    decimals: 18,
  },
  faucetUrl: 'https://faucet.polkadot.io/',
} as const;

// Zero address constant for comparison
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

// Contract addresses - Deployed to Paseo AssetHub Testnet (2026-01-14 - v4 with multi-slot saves)
export const CONTRACT_ADDRESSES = {
  // Core contracts
  GAME: '0xb3a87B4b8EBA489F60673757981F10011F2C2d38' as string,      // CrystalsGame (main orchestrator)
  COMBAT: '0x4a03F476e6ead124e22D03f86018407719D9f4b1' as string,
  PARTY: '0x9805219f9ba3722C9F01317AB6596185d001cED3' as string,
  WORLD: '0xB46C76039549dB063caB7a1872620f247abc4d68' as string,
  MAGIC: '0x218521710F82C6b7C436Aad29e2F97EBA4f7a13B' as string,

  // Data contracts
  CLASS_DATA: '0x8F929Eb9C7179B16F0362D554020AFf13F6029A9' as string,
  ITEM_DATA: '0x496E55A06526ced533A288a423B6Cb6E128A2645' as string,
  SPELL_DATA: '0x520e670e26d3f357F0f82963177a821b07782466' as string,
  ENEMY_DATA: '0x07B3124AC5e5AAd4730d69638AdF4AC75daa5Cf6' as string,

  // Systems
  RANDOMNESS: '0x1bc273eBDE4852E01FE25BfA0FA8f8A127A00FA5' as string,
  SHOP: ZERO_ADDRESS as string,       // Not yet deployed
  INN: ZERO_ADDRESS as string,        // Not yet deployed
  TRANSPORT: ZERO_ADDRESS as string,  // Not yet deployed

  // NFT contracts
  SAVE_NFT: ZERO_ADDRESS as string,   // Not yet deployed
  ACHIEVEMENT_SBT: ZERO_ADDRESS as string, // Not yet deployed
};

// After deployment, update these addresses from:
// ../../../contracts/deployments/paseo.json

// Gas limits for different operations
export const GAS_LIMITS = {
  CREATE_GAME: 300000,
  MOVE: 50000,
  ATTACK: 80000,
  CAST_SPELL: 100000,
  USE_ITEM: 60000,
  FLEE: 40000,
  BUY_ITEM: 50000,
  SELL_ITEM: 40000,
  EQUIP_ITEM: 30000,
  REST: 60000,
} as const;

// Block explorer URL builder
export const getExplorerUrl = (type: 'tx' | 'address' | 'block', value: string): string => {
  switch (type) {
    case 'tx':
      return `${NETWORK_CONFIG.explorerUrl}/tx/${value}`;
    case 'address':
      return `${NETWORK_CONFIG.explorerUrl}/address/${value}`;
    case 'block':
      return `${NETWORK_CONFIG.explorerUrl}/block/${value}`;
    default:
      return NETWORK_CONFIG.explorerUrl;
  }
};

// Contract deployment info type
export interface DeploymentInfo {
  address: string;
  blockNumber: number;
  deployer: string;
  timestamp: number;
  transactionHash: string;
}

// Function to load deployment info from file
export const loadDeploymentInfo = async (): Promise<Record<string, DeploymentInfo> | null> => {
  try {
    // This would load from the deployment JSON file
    // For now, return null (will be implemented after deployment)
    return null;
  } catch (error) {
    console.error('Failed to load deployment info:', error);
    return null;
  }
};
